import { atom } from 'recoil';

import type { AsyncAtomData } from './useAsyncAtomState';
import { useAsyncAtomState } from './useAsyncAtomState';

import type { StudyCard } from '../domain/StudySession';

export const initialStudyCardState: AsyncAtomData<StudyCard | null> = {
  data: null,
  error: null,
  received: false,
  updating: false,
};

export const studyCardState = atom<AsyncAtomData<StudyCard | null>>({
  key: 'studyCardState',
  default: initialStudyCardState,
});

export const useStudyCardState = () => useAsyncAtomState(studyCardState);
